import type { PartnerReduced, Service, Supplier, AcquiredService } from "@kappa-v2/contracts";
import { EntityCombo } from "./EntityCombo.js";

interface BaseProps {
  value: string;
  onChange: (id: string) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const eur = (n?: number) => `€ ${(n ?? 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;

// `active`: filtra i soci proposti — "all" (default) | "true" (solo attivi) | "false" (solo non attivi).
export function ComboPartners({ label = "Socio", active = "all", ...rest }: BaseProps & { active?: "all" | "true" | "false" }) {
  return (
    <EntityCombo<PartnerReduced>
      label={label}
      path={`/api/v1/partners/reduced?active=${active}`}
      mapItem={(p) => ({ id: String(p._id), label: p.fullName ?? `${p.lastName} ${p.firstName}`, sub: p.contact })}
      {...rest}
    />
  );
}

export function ComboSuppliers({ label = "Fornitore", ...rest }: BaseProps) {
  return (
    <EntityCombo<Supplier>
      label={label}
      path="/api/v1/suppliers/reduced?active=all"
      mapItem={(s) => ({
        id: String(s._id),
        label: s.companyName || [s.lastName, s.firstName].filter(Boolean).join(" ") || "—"
      })}
      {...rest}
    />
  );
}

export function ComboServices({ label = "Servizio", ...rest }: BaseProps) {
  return (
    <EntityCombo<Service>
      label={label}
      path="/api/v1/services"
      mapItem={(s) => ({ id: String(s._id), label: s.name, sub: eur(s.price) })}
      {...rest}
    />
  );
}

export function ComboAcqServices({ label = "Servizio acquisito", ...rest }: BaseProps) {
  return (
    <EntityCombo<AcquiredService>
      label={label}
      path="/api/v1/acqservices"
      mapItem={(a) => ({ id: String(a._id), label: a.name, sub: eur(a.price) })}
      {...rest}
    />
  );
}
